import reportError from './report-error'

const services = {
  reportError,
}

export default services
